import React from 'react';
import { AutocompleteArrayInput, Identifier, Validator, required } from 'react-admin';

interface AccountPermissionBillingGroupInputProps {
  disabled: boolean;
  choices: { id: Identifier; name: string }[];
  validation?: Validator | Validator[];
}

const AccountPermissionBillingGroupInput = ({
  choices,
  disabled,
  validation = required(),
}: AccountPermissionBillingGroupInputProps) => (
  <div style={{ position: 'relative' }}>
    {/* The disable props doesn't work. This element is to cover the input and making it unselectable */}
    {disabled && (
      <div
        style={{
          height: '100%',
          width: '100%',
          zIndex: 1,
          position: 'absolute',
          cursor: 'not-allowed',
        }}
      />
    )}
    <AutocompleteArrayInput
      key={`billing_group_ids-${disabled}`}
      source="billing_group_ids"
      choices={choices}
      disabled={disabled}
      validate={disabled ? undefined : validation}
      data-testid="account-permission_billing_group"
    />
  </div>
);

export default AccountPermissionBillingGroupInput;
